import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './app/App'
import * as serviceWorker from './serviceWorker'

import 'font-awesome/css/font-awesome.min.css'
import './assets/icon-fonts/simple-line-icons/simple-line-icons.css'
import './assets/icon-fonts/typicons/typicons.css'

ReactDOM.render(
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>,
  document.getElementById('root'),
)

serviceWorker.unregister()
